const es = {
  nav: { plans: "Planes", howItWorks: "Cómo Funciona", contact: "Contacto", support: "Soporte", consultData: "Consultar Datos", login: "Login", portal: "Mi Cuenta", crm: "CRM", services: "Servicios", chipMobile: "Chip NewSky Mobile", wifiService: "NewSky WiFi" },

  hero: {
    brand: "Mobile",
    overline: "La conexión que necesitas en Japón",
    headline: "Internet + Número Telefónico Japonés",
    headlineAccent: "¡sin burocracia!",
    sub: "¡Sin multa al cancelar! ¡Úsalo el tiempo que necesites!",
    sub2: "Chip físico o eSIM con soporte en tu idioma!",
    ctaBuy: "¡Quiero el mío!",
    ctaPlans: "Ver planes",
  },

  benefits: {
    overline: "Ventajas",
    title: "Todo lo que necesitas",
    items: [
      { title: "Conexión estable en todo Japón", desc: "Cobertura 4G/5G de alta velocidad en todas las regiones de Japón." },
      { title: "Súper económico", desc: "Planes desde ¥3,480/mes con llamadas incluidas." },
      { title: "Sin burocracia", desc: "Proceso simple y rápido. Sin contratos largos." },
      { title: "Pago en konbini o tarjeta", desc: "Paga como te sea más fácil. Konbini, tarjeta de crédito o transferencia." },
      { title: "Tasa de activación promocional", desc: "Aprovecha la tasa de activación con descuento especial." },
      { title: "Chip físico o eSIM en el mismo día", desc: "Elige entre SIM físico o eSIM. Activación inmediata." },
    ],
  },

  plans: {
    overline: "Planes",
    title: "Elige tu plan ideal",
    sub: "Planes con número japonés, datos y llamadas. Empieza a usar hoy.",
    basic: "Básico",
    popular: "Popular",
    premium: "Premium",
    badge: "Más Elegido",
    unlimitedCalls: "Llamadas ilimitadas",
    calls60: "60 min llamadas",
    month: "mes",
    optional: "Opcional",
    unlimitedPlus: "Llamadas ilimitadas",
    activationFee: "Tasa única de activación: ¥3,300",
    cta: "Quiero más información",
    features: {
      data: "de datos",
      callsUnlimited: "Llamadas ilimitadas",
      calls60min: "60 min de llamadas",
      jpNumber: "Número japonés",
      simOrEsim: "Chip físico o eSIM",
      supportPt: "Soporte en portugués",
      supportPriority: "Soporte prioritario",
    },
  },

  howItWorks: {
    overline: "Simple y rápido",
    title: "Cómo funciona",
    steps: [
      { title: "Elige el plan", desc: "Selecciona el plan ideal para tus necesidades de datos y llamadas." },
      { title: "Recibe el chip o eSIM", desc: "Recibe tu SIM físico en casa o activa el eSIM al instante." },
      { title: "Activa y usa", desc: "Inserta el chip o escanea el código QR del eSIM. ¡Listo, estás conectado!" },
    ],
  },

  trust: {
    overline: "Confianza y Tradición",
    title: "Más de 25 años conectando personas en Japón",
    desc: "NewSky lleva más de dos décadas en Japón, ofreciendo servicios de telecomunicaciones con atención dedicada en portugués, español e inglés. Más de 100 mil clientes satisfechos confían en nuestra experiencia.",
    stats: { years: "Años en Japón", customers: "Clientes atendidos", languages: "Idiomas de soporte", response: "Respuesta rápida" },
    langs: ["Portugués", "Español", "Inglés"],
  },

  contact: {
    overline: "Contáctanos",
    title: "Ponte en contacto",
    form: { name: "Nombre", email: "Correo", phone: "Teléfono", message: "Mensaje", namePh: "Tu nombre", emailPh: "tu@correo.com", phonePh: "090-XXXX-XXXX", messagePh: "¿Cómo podemos ayudarte?", submit: "Enviar mensaje", sending: "Enviando...", success: "¡Mensaje enviado!", error: "Error. Inténtalo de nuevo." },
    info: { tokyo: "Tokio", email: "Correo", whatsapp: "WhatsApp", whatsappSub: "Atención solo por texto", hours: "Horario de atención", monFri: "Lunes a Viernes", sat: "Sábado", hq: "NewSky - Sede Central", hqAddr: "163-1030 Tokyo-to Shinjuku-ku Nishi-Shinjuku 3-7-1 Shinjuku Park Tower N30F", hqNote: "(sin atención al cliente)", office: "NewSky - Oficina de Atención al Cliente", officeAddr: "485-0048 Aichi-ken Komaki-shi MamaHonMachi 123 BB komaki Bldg. 3F" },
  },

  finalCta: {
    overline: "No pierdas más tiempo",
    title: "Llega a Japón ya conectado",
    desc: "Ten tu número japonés e internet funcionando antes de salir del aeropuerto. Habla con nosotros ahora.",
    cta: "¡Quiero el mío!",
  },

  supportPage: {
    overline: "Centro de Ayuda",
    title: "¿Cómo podemos ayudarte?",
    sub: "Encuentra respuestas a las preguntas más frecuentes o contacta a nuestro equipo.",
    searchPh: "Buscar en soporte...",
    faqTitle: "Preguntas Frecuentes",
    noResults: "No se encontraron resultados para",
    needHelp: "¿Aún necesitas ayuda?",
    whatsapp: "WhatsApp",
    whatsappSub: "Respuesta rápida",
    phone: "Teléfono",
    emailLabel: "Correo",
    backHome: "Volver al inicio",
    faqs: [
      { q: "¿Cómo activo mi eSIM?", a: "Después de la compra, recibirás un código QR por correo. Ve a los ajustes de tu celular, toca 'Datos Móviles' o 'Red Celular', selecciona 'Agregar Plan' y escanea el código QR. Tu eSIM se activará en pocos minutos." },
      { q: "¿Qué celulares son compatibles con eSIM?", a: "La mayoría de los smartphones modernos son compatibles, incluyendo iPhone XS y posteriores, Samsung Galaxy S20+, Google Pixel 3 y posteriores. Consúltanos por WhatsApp para verificar la compatibilidad de tu dispositivo." },
      { q: "¿Puedo conservar mi número actual?", a: "¡Sí! Ofrecemos el servicio de portabilidad (MNP). Puedes transferir tu número actual a NewSky Mobile. Contáctanos para más detalles sobre el proceso." },
      { q: "¿Cómo funciona el pago en konbini?", a: "Recibirás un comprobante por correo o SMS que puedes pagar en cualquier konbini (7-Eleven, FamilyMart, Lawson, etc). El pago se procesa en hasta 24 horas." },
      { q: "¿Cuál es la cobertura de la red?", a: "Nuestra red cubre todo el territorio japonés, incluyendo áreas rurales. Utilizamos la infraestructura de las principales operadoras de Japón, garantizando conexión 4G/5G de alta calidad en todo el país." },
      { q: "¿Puedo cancelar en cualquier momento?", a: "¡Sí! Nuestros planes no tienen fidelidad ni multa de cancelación. Puedes cancelar en cualquier momento contactándonos por WhatsApp o teléfono." },
      { q: "¿Cómo recibo el chip físico?", a: "El chip físico se envía por Japan Post. La entrega normalmente toma de 1 a 3 días hábiles. También puedes retirarlo en nuestra oficina en Tokio." },
      { q: "¿Necesito documentos para contratar?", a: "Sí, necesitas un documento de identificación válido (pasaporte o Residence Card). El proceso es simple y se puede hacer completamente por WhatsApp." },
    ],
  },

  consultar: {
    title: "Consultar Uso de Datos",
    desc: "Para verificar el consumo de datos e información de tu chip NewSky Mobile, ingresa el número de tu SIM Card",
    label: "Número del SIM Card",
    placeholder: "Ingresa el número del SIM",
    button: "Consultar",
    consulting: "Consultando...",
    result: "Resultado de la Consulta",
    newSearch: "Nueva consulta",
    simInfo: "El número del SIM Card está impreso en la tarjeta del chip o se puede encontrar en los ajustes de tu dispositivo.",
    number: "Número",
    dataUsage: "Consumo de Datos",
    used: "utilizado",
    remaining: "restante",
    plan: "Plan",
    network: "Red",
    sim: "SIM",
    voice: "Voz",
    sms: "SMS",
    planStart: "Inicio Plan",
    active: "Activo",
    suspended: "Suspendido",
    details: "Detalles del SIM",
    serialNumber: "Número de Serie",
    activation: "Activación",
    calls: "Llamadas",
    callsUnlimited: "Ilimitadas (70 min/llamada)",
    planStartDate: "Inicio del Plan",
    planEndDate: "Fin del Plan",
    noExpiry: "Sin vencimiento",
    error: "Error al consultar. Inténtalo de nuevo.",
    notFound: "SIM no encontrado o número inválido",
  },

  footer: { back: "Volver" },

  wifi: {
    overline: "WiMAX 5G — Internet Ilimitado",
    headline: "Internet de alta velocidad",
    headlineAccent: "¡en cualquier lugar!",
    sub: "Sin cables. Sin técnico. Sin tarifa de instalación. Sin esperas.",
    sub2: "¡Internet ilimitado para toda la familia en segundos!",
    ctaBuy: "¡Quiero el mío!",
    ctaPlans: "Ver planes",
    familyText: "¡Internet para toda la familia!",
    benefitsTitle: "¿Por qué elegir NewSky WiFi?",
    benefitsOverline: "Ventajas",
    benefits: [
      { title: "Sin cables, sin instalación", desc: "¡Llega, enciende y conecta! Sin técnico, sin perforaciones, sin esperas." },
      { title: "Internet ilimitado", desc: "Datos ilimitados para streaming, trabajo, juegos y toda la familia." },
      { title: "Llévalo donde quieras", desc: "En casa, en el trabajo, de viaje. Batería de larga duración para todo el día." },
      { title: "Sin tarifas altas", desc: "Sin tarifa de instalación absurda. Sin cargos extras al mudarte." },
      { title: "Conecta hasta 16 dispositivos", desc: "Celular, laptop, tablet, smart TV, consola — todos al mismo tiempo." },
      { title: "Velocidad 5G WiMAX", desc: "Tecnología de punta con máximo rendimiento para tu conexión." },
    ],
    plansOverline: "Planes",
    plansTitle: "Elige tu forma de pago",
    plansSub: "Internet ilimitado WiMAX 5G — ¡Dispositivo 100% nuevo!",
    konbini: "💴 Pago en Konbini",
    card: "💳 Débito Automático en Tarjeta",
    planSky1: "Plan Sky 1",
    planSky2: "Plan Sky 2",
    tabRent: "Alquilar Dispositivo",
    tabBuy: "Comprar Dispositivo",
    month: "/mes",
    unlimitedRental: "Internet ilimitado + alquiler del dispositivo",
    deviceNew: "🎉 ¡DISPOSITIVO 100% NUEVO!",
    activationFee: "Tarifa de activación",
    shippingFee: "Envío a todo Japón",
    totalInitial: "Total inicial",
    monthlyLabel: "Mensualidad:",
    campaign: "Campaña Especial",
    buyBonus: "🎁 ¡Al comprar recibes:",
    exempt: "EXENTO",
    free: "GRATIS",
    shippingFree: "a todo Japón",
    monthlyReduction: "Mensualidad",
    unlimitedInternet: "Internet ilimitado",
    paymentKonbini: "📅 Pago entre el 2 y 15 del mes posterior",
    paymentCard: "💳 Débito automático en tarjeta el mes posterior",
    noCancel: "✓ Sin multa de cancelación",
    minPeriod: "⏱ Período mínimo: 2 meses",
    cta: "Quiero más información",
    konbiniNote: "Valor a pagar al repartidor al recibir en casa:",
    cardNote: "Enviaremos la factura para pago seguro con tarjeta:",
  },

  portal: {
    loginTitle: "Portal del Cliente", loginSub: "Accede a tus servicios y pagos",
    email: "Correo", emailPh: "tu@correo.com", password: "Contraseña", passwordPh: "Tu contraseña",
    enter: "Iniciar Sesión", demo: "Iniciar sesión con cuenta Demo",
    forgot: "Olvidé mi contraseña", forgotTitle: "Recuperación de Contraseña",
    forgotDesc: "Para restablecer tu contraseña, contacta a nuestro soporte:",
    forgotClose: "Cerrar", backToSite: "Volver al sitio",
    portalLabel: "Portal",
    nav: { home: "Inicio", services: "Servicios", payments: "Pagos", support: "Soporte", account: "Mi Cuenta", logout: "Salir" },
    hello: "Hola,", welcome: "Bienvenido a tu portal NewSky Mobile",
    monthlyTotal: "TOTAL MENSUAL", pending: "PENDIENTE",
    myServices: "Mis Servicios", viewAll: "Ver todos", noActiveService: "Sin servicios activos",
    nextBilling: "Próx. cobro:", overdueWarning: "Atención: {count} servicio(s) con pago vencido",
    overdueContact: "Contacta al soporte para resolver.", pendingPayments: "Pagos Pendientes",
    dueDate: "Vence:", overdue: "VENCIDO", pendingLabel: "PENDIENTE", month: "/mes",
    myServicesTitle: "Mis Servicios", noServiceFound: "No se encontraron servicios",
    since: "Desde", upgrade: "Upgrade", downgrade: "Downgrade", cancel: "Cancelar",
    requestTitle: "Solicitar", requestDesc: "Describe tu solicitud...", sendRequest: "Enviar Solicitud", cancelBtn: "Cancelar",
    myRequests: "Mis Solicitudes", reqType: "Tipo", reqDetails: "Detalles", reqDate: "Fecha", reqStatus: "Estado",
    reqPending: "Pendiente", reqApproved: "Aprobado", reqRejected: "Rechazado",
    statusActive: "ACTIVO", statusOverdue: "VENCIDO", statusCancelled: "CANCELADO",
    paymentsTitle: "Pagos", totalPaid: "Total Pagado", pendingAmount: "Pendiente", overdueAmount: "Vencido",
    openInvoices: "Facturas Abiertas", invoices: "Facturas", payNow: "Pagar Ahora",
    paid: "PAGADO", open: "ABIERTA", history: "Historial", noPayment: "Sin pagos",
    amount: "Monto", dueDateLabel: "Vencimiento", paymentDate: "Pago", status: "Estado",
    supportTitle: "Soporte", supportEmpty: "Envía un mensaje para iniciar la conversación.",
    supportTeam: "Nuestro equipo responderá pronto.", typePlaceholder: "Escribe tu mensaje...",
    accountTitle: "Mi Cuenta", personalData: "Datos Personales", name: "Nombre",
    nameChangeNote: "Para cambiar tu nombre, contacta al soporte.", phone: "Teléfono",
    save: "Guardar Cambios", saved: "¡Datos actualizados correctamente!",
  },
};

export default es;
